import { createContext, useContext } from 'react';

interface CellulaProviderContext {
	cellulaId: string;
	portalElement: HTMLElement;
}

export const CellulaProviderContext = createContext<CellulaProviderContext>(undefined as unknown as CellulaProviderContext);

export function /**/ useCellulaProviderContext(): CellulaProviderContext {
	const cellulaProviderContext = useContext(CellulaProviderContext);
	if (cellulaProviderContext === undefined) {
		throw new Error('useCellulaProviderContext must be used within a CellulaProvider');
	}

	return cellulaProviderContext;
}
